import { useTranslation } from 'next-i18next';
import { Button } from '@wbk/ui';
import PaymentMethods from '@/components/common/PaymentMethods';

const StickyMatchInfo = () => {
  const { t } = useTranslation();

  return (
    <div className='sticky top-2 divide-white/40'>
      <h3 className='pb-2 pt-4'>{t('event:need_help')}</h3>
      <Button
        as='a'
        shape='outlined'
        theme='white'
        className='w-full'
        href='https://ittihadclub.sa/contact-us'
        data-info='support'
        target='_blank'
        rel='noopener noreferrer'
      >
        {t('event:support')}
      </Button>

      <div className='rounded-lg pt-12 lg:hidden'>
        <PaymentMethods />
      </div>
    </div>
  );
};

export default StickyMatchInfo;
